export { WindProject } from './wind-project.component';
